// Departure charge (server/automations/carDepartureCharge.js): plan, weekly
// schedule and the one-off override. Thin fetchers only.
import { apiFetch } from './api.js'

const BASE = (import.meta.env.VITE_API_BASE ?? '/api') + '/car-departure'

export async function fetchCarDeparture() {
  const r = await apiFetch(`${BASE}/status`)
  if (!r.ok) throw new Error(`car-departure ${r.status}`)
  return r.json()
}

/** PATCH settings; resolves to the fresh status payload. */
export async function patchCarDeparture(fields) {
  const r = await apiFetch(`${BASE}/settings`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(fields),
  })
  if (!r.ok) throw new Error(`car-departure ${r.status}`)
  return r.json()
}

/** Answer plan.short: 'cheap' = stop when the cheap window ends, 'finish' = day rate until the target. */
export async function chooseCarDepartureShort(choice) {
  const r = await apiFetch(`${BASE}/short`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ choice }),
  })
  if (!r.ok) throw new Error(`car-departure ${r.status}`)
  return r.json()
}

// Guest charging (server/automations/guestCharge.js). Both resolve to { active, recent, modes }.
const GUEST = (import.meta.env.VITE_API_BASE ?? '/api') + '/guest-charge'

export async function startGuestCharge(mode, name) {
  const r = await apiFetch(`${GUEST}/start`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ mode, name }),
  })
  if (!r.ok) throw new Error(`guest-charge ${r.status}`)
  return r.json()
}

export async function stopGuestCharge() {
  const r = await apiFetch(`${GUEST}/stop`, { method: 'POST' })
  if (!r.ok) throw new Error(`guest-charge ${r.status}`)
  return r.json()
}
